import { render, staticRenderFns } from "./ProjectMedicalDetails.vue?vue&type=template&id=a1dec1b0&"
import script from "./ProjectMedicalDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectMedicalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports